const PaymentCancelled = () => {
    return (
        <div className="text-center mt-20">
            <h1 className="text-2xl font-bold">Payment Cancelled 😞</h1>
            <p>You can try subscribing again anytime.</p>
        </div>
    );
}

export default PaymentCancelled;